import React, {useContext} from 'react';
import {InsuranceContext} from "../InsuranceContext";
import InsuranceInput from "./index";

function InsuranceInputHolder(props) {
  const helper = useContext(InsuranceContext);
  const setMyData = helper.setMyData
  const myData = helper.myData

  const {row, objectKey, functionAfterSelect,variables,className} = props

  const value = myData.sendData[objectKey][row.name]

  return (<InsuranceInput
    value={value}
    objectKey={objectKey}
    row={row}
    functionAfterSelect={functionAfterSelect}
    variables={variables}
    className={className}
  />);
}

export default InsuranceInputHolder;